import { PauseCircle } from "@phosphor-icons/react";
import { downloadMyMemories } from "@/components/AccountDataDialog";

const fmt = (iso) => new Date(iso).toLocaleDateString("en-AU", { day: "numeric", month: "long", year: "numeric" });

export const PausedBanner = ({ deleteAt, onUpgrade, onManage }) => (
  <div data-testid="paused-banner" className="rounded-xl border border-[#A84A32]/30 bg-[#F7E3DE] p-5">
    <div className="flex items-start gap-3">
      <PauseCircle size={24} weight="duotone" className="mt-0.5 shrink-0 text-[#A84A32]" />
      <div>
        <p className="font-medium text-[#2C2A28]">Your free trial has ended, so your diary is paused</p>
        <p className="mt-1 text-sm leading-relaxed text-[#4A4540]">
          You can still read and download your memories, but you can't add new ones. Unless you upgrade, your account and memories will be
          <strong> permanently deleted on <span data-testid="paused-delete-date">{fmt(deleteAt)}</span></strong>.
        </p>
      </div>
    </div>
    <div className="mt-4 flex flex-wrap gap-2 sm:pl-9">
      <button data-testid="paused-upgrade-btn" onClick={onUpgrade} className="rounded-full bg-[#E07A5A] px-5 py-2 text-sm font-semibold text-white hover:bg-[#d66b4b]">Upgrade and keep my memories (A$23.99)</button>
      <button data-testid="paused-download-btn" onClick={downloadMyMemories} className="rounded-full bg-[#2E3B31] px-5 py-2 text-sm font-semibold text-[#FBF4E8]">Download my memories</button>
      <button data-testid="paused-delete-btn" onClick={onManage} className="rounded-full border border-[#A84A32]/40 px-5 py-2 text-sm font-semibold text-[#A84A32]">Delete my account now</button>
    </div>
  </div>
);
